exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".area-text{position:absolute;z-index:9999}.mul-textarea{width:100%;min-height:120px;resize:none;border:1px solid #dcdfe6;background-color:#fff;-webkit-appearance:none;color:#515a6e;outline:none;padding:10px}.mul-textarea::-webkit-input-placeholder{color:#c0c4cc}.mul-textarea:-moz-placeholder,.mul-textarea::-moz-placeholder{color:#c0c4cc}.mul-textarea:-ms-input-placeholder{color:#c0c4cc}.dyt-textarea .el-input__inner{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
